import { startGame } from '@fg/base/main';
import { Scene } from '@fg/base/scene';
import { AlignGrid } from '@fg/base/phaser_utilities/align_grid';
import store from '@fg/base/store';

let coinsAnim;

class GameScene extends Scene {
    update() {
        super.update();
    }

    init() {
        super.init();

        this.mainSound = this.sound.add('mus-basegame', {"loop":true});
        this.mainAmbSound = this.sound.add('amb-main', {"loop":true});
        this.mainSound.play();
        this.mainAmbSound.play();

        store.commit('toggleExplanation', {
            callback: () => {
                this.letInitialize(() => {
                    this.prepareSounds();
                    this.positionerContainer = this.add.container();
                    this.createClouds();
                    this.mainGameGroup = this.add.container();
                    this.createBg();
                    this.frontContainer = this.add.container();
                    this.createGameItems()
                    this.createBonus()
                    this.createLightnings();
                    this.createFader();
                    this.createCoinsBurster();
                    this.spritesReady = true;
                    this.baseGamePositioner();
                    this.canvasReady();
                });
            }
        });
    }

    prepareSounds() {
        this.bonusSound = this.sound.add('mus-bonus', {"loop":true, "volume": 0});
        this.bonusAmbSound = this.sound.add('amb-bonus', {"loop":true, "volume": 0});
        this.pointCountSound = this.sound.add('sfx-point-count', {"loop":true, "volume": 1});
    }

    beforePurchase() {
        this.sound.play('sfx-btn-play');
    }

    shootZeusLightningTo(toX, toY) {
        let zeus = this.zeus;

        if (this.orientationIsSetToPortrait()) {
            zeus = this.zeusPortrait;
        }

        this.zeusLightning.setX(zeus.x).setY(zeus.y - 610);
        this.lightningShort.setX(this.zeusLightning.x + this.zeusLightning.width - 200).setY(this.zeusLightning.y + 170);
        this.lightningMedium.setX(this.lightningShort.x).setY(this.lightningShort.y);
        this.lightningLong.setX(this.lightningShort.x).setY(this.lightningShort.y);

        let currentLightning = this.lightningShort;

        let distance = Phaser.Math.Distance.Between(this.lightningShort.x, this.lightningShort.y, toX, toY) + 30;

        if (distance > this.lightningShort.width) {
            currentLightning = this.lightningMedium;

            if (distance > this.lightningMedium.width) {
                currentLightning = this.lightningLong;
            }
        }

        currentLightning.setScale(distance / currentLightning.width);

        let point = Phaser.Math.Angle.Between(currentLightning.x, currentLightning.y, toX, toY);

        this.sound.play('sfx-zeus-fire');
        this.zeusLightning.play('zeus_lightning');
        currentLightning.rotation = point;
        currentLightning.play(currentLightning.animationName);
    }

    shootLightningFromTo(fromX, fromY, toX, toY) {
        let currentLightning = this.add.sprite(fromX, fromY, 'lightning_short').setOrigin(0, 0.5).setVisible(false);

        let distance = Phaser.Math.Distance.Between(fromX, fromY, toX, toY) + 30;

        if (distance > this.lightningShort.width) {
            currentLightning.destroy();
            currentLightning = this.add.sprite(fromX, fromY, 'lightning_medium').setOrigin(0, 0.5).setVisible(false);

            if (distance > this.lightningMedium.width) {
                currentLightning.destroy();
                currentLightning = this.add.sprite(fromX, fromY, 'lightning_long').setOrigin(0, 0.5).setVisible(false);
            }
        }

        currentLightning.setScale(distance / currentLightning.width);

        let point = Phaser.Math.Angle.Between(currentLightning.x, currentLightning.y, toX, toY);

        currentLightning.rotation = point;
        currentLightning.play(currentLightning.texture.key);

        currentLightning.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
            currentLightning.destroy();
        });
    }

    createCoinsBurster() {
        let animationConfig = {
            key: 'coins',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNumbers('coins', {
                start: 0,
                end: 7,
            }),
            frameRate: 25,
            repeat: -1
        };

        coinsAnim = this.anims.create(animationConfig);

        const particles = this.add.particles('coins');

        this.coinsEmitter = particles.createEmitter({
            frame: 0,
            x: 0,
            y: 0,
            lifespan: 2000,
            speedY: { min: 100, max: -500 },
            speedX: { min: -300, max: 300 },
            particleClass: AnimatedParticle,
            gravityY: 1000,
            quantity: 1,
            on: false
        });
    }

    burstCoins(x, y) {
        this.sound.play('sfx-coin-match');
        this.coinsEmitter.setPosition(x, y);
        this.coinsEmitter.explode(30);
    }

    afterPurchase() {
        this.symbolsOpened = 0;
        this.bonusSymbolsOpened = 0;
        this.bonusRunning = false;
        this.winAllRunning = false;
        this.allNeededBonusItemsOpened = false;
        this.multiplierFinished = false;
        this.mappedLuckies = {};
        this.openedYourSymbolsLucky = [];
        this.yourSymbolsOpeningSequence = [];
        this.bonusTweens = [];
        
        this.afterPurchaseAnimation();
    }

    afterPurchaseAnimation() {
        if(this.request.gamePlayedTimes > 0) {
            this.resetGame(() => {
                this.loadSymbols(() => {
                    store.commit('showOpenAllButton');
                });
            });
        } else {
            this.loadSymbols(() => {
                store.commit('showOpenAllButton');
            });
        }
    }

    resetGame(callback) {
        this.sound.play('sfx-metal-new-game');

        for(let i = 0; i < 4; i++) {
            let item = this.mainGameItems['lucky_symbols'][i];
            item.opened = false;
        }

        for(let i = 0; i < 14; i++) {
            let item = this.mainGameItems['your_symbols'][i];
            item.setAlpha(1);
            item.opened = false;
            item.amount_after = 0;

            if (item.amount) {
                item.amount.destroy();
            }
        }

        for(let i = 0; i < 10; i++) {
            let item = this.bonusItems[i];
            item.opened = false;

            item.setTexture('bonus_token').setVisible(true);

            if (item.amount) {
                item.amount.destroy();
            }

            if (item.flamesContainer) {
                item.flamesContainer.destroy();
            }
        }

        if (this.winAllTempSymbol) {
            this.winAllTempSymbol.destroy();
        }

        this.omegaCover.playReverse('omega_cover_animation');

        this.jackpotIndicator.play('jackpot_indicator_close');

        this.jackpotIndicator.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
            this.jackpotIndicatorSymbol.setTexture('');
            callback();
        });
    }

    ticketFinished() {
        store.commit('hideOpenAllButton');
        this.request.ticketFinished();
    }

    afterComplete() {
    }

    openAll() {
        if(this.bonusStarted || this.winAllRunning) {
            return;
        }
        
        let symbolOpened = false;
        
        for (let [index, item] of Object.entries(this.mainGameItems['your_symbols'])) {
            if(!item.opened) {
                this.openYourSymbol(item.absoluteIndex, item);

                const scenarioItem = this.request.scenario.your_symbols[this.symbolsOpened-1];
    
                if (['bonus_all_symbol', 'bonus_symbol'].includes(scenarioItem)) {
                    return;
                }

                symbolOpened = true;
    
                if (Config.assets.settings.disable_open_all && symbolOpened && parseInt(index) === 7) {
                    return;
                }
            }
        }
    }

    createClouds() {
        this.cloudLayer1 = this.add.sprite(0, 0, 'cloud_layer_1').setOrigin(1, 0);
        this.cloudLayer2 = this.add.sprite(0, 0, 'cloud_layer_2').setOrigin(1, 0);
        this.cloudLayer3 = this.add.sprite(0, 0, 'cloud_layer_3').setOrigin(0, 0);
        this.cloudLayer4 = this.add.sprite(0, 0, 'cloud_layer_4').setOrigin(1, 0);

        this.bonusDarkFader = this.add.graphics().fillStyle(0x000000, 1).fillRect(0, 0, 1920, 1920).setAlpha(0);
        this.zeusPortrait = this.add.sprite(0, 0, 'h_zeus').setOrigin(0, 1);
        this.templePortrait = this.add.sprite(0, 0, 'v_temple').setOrigin(1, 1);
        this.cloudLayer5 = this.add.sprite(0, 0, 'v_front_clouds').setOrigin(0, 1);
        this.cloudLayer6 = this.add.sprite(0, 0, 'v_front_clouds').setOrigin(0, 1);
    }
    createBg() {
        this.bg = this.add.sprite(0, 0, 'bg').setOrigin(0.5, 1);
        this.positionerContainer.add(this.bg);

        this.zeus = this.add.sprite(0, 0, 'h_zeus').setOrigin(0, 1);
        this.temple = this.add.sprite(0, 0, 'h_temple').setOrigin(1, 1);
        this.mainGameGroup.add(this.temple);

        this.mainFrame = this.add.sprite(0, 0, 'main_frame').setOrigin(0.5, 0);
        this.mainGameGroup.add(this.mainFrame);

        this.omegaCoverFx = this.add.sprite(0, 0, 'multiplier_fx').setOrigin(0.5, 0.5).setVisible(false);
        this.mainGameGroup.add(this.omegaCoverFx);

        this.omegaCoverMultiplier = this.add.sprite(0, 0, 'x1').setOrigin(0.5, 0.5);
        this.mainGameGroup.add(this.omegaCoverMultiplier);

        this.omegaCover = this.add.sprite(0, 0, 'omega_cover').setOrigin(0.5, 1);
        this.mainGameGroup.add(this.omegaCover);

        this.logo = this.add.sprite(0, 0, 'logo');

        let animationConfig = {
            key: 'omega_cover_animation',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('omega_cover_animation',
            {
                prefix: 'Omega_Cover_Shatter_',
                start: 0,
                end: 56,
                suffix: '.png',
                zeroPad: 4
            }),
            frameRate: 25
        };

        this.anims.create(animationConfig);

        animationConfig = {
            key: 'multiplier_fx',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('multiplier_fx',
            {
                prefix: 'Multiplier_FX_',
                start: 0,
                end: 52,
                suffix: '.png',
                zeroPad: 4
            }),
            frameRate: 25,
            showOnStart: true,
            hideOnComplete: true
        };

        this.anims.create(animationConfig);
    }

    flipUpSymbol(item, symbol, color, callback) {
        if (symbol === 'bonus_all_symbol') {
            symbol = this.request.scenario.win_all_bonus.symbol;
        }

        let shieldColor = color === 'gold' ? 'gold' : 'blue';

        item.play(`shield_${shieldColor}_flip_down`);
        item.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
            item.play(`symbol_${color}_${symbol}_flip_up`);

            item.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                if (callback) {
                    callback();
                }
            });
        });
    }

    flipShield(item, color, delay) {
        this.time.delayedCall(delay, () => {
            item.play(`shield_${color}_flip_down`);

            item.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                item.play(`shield_${color}_flip_up`);

                if (color === 'blue') {
                    item.greyItem.setAlpha(0);
                    item.greyItem.setTexture('');
                }
            });
        });
    }

    loadSymbols(callback) {
        this.jackpotIndicatorSymbol.setTexture(`jackpot_indicator_symbol_${this.request.scenario.win_all_bonus.symbol}`);
        this.jackpotIndicatorSymbol.setScale(0.8);

        for (let i = 0; i < this.request.scenario.lucky_symbols.length; i++) {
            this.mappedLuckies[this.request.scenario.lucky_symbols[i]] = this.mainGameItems['lucky_symbols'][i];
        }

        this.tweens.add({
            targets:  [this.mainSound, this.mainAmbSound],
            volume:  0.5,
            duration: 500
        });
        
        this.tweens.add({
            targets: this.fullFaderMain,
            alpha: 0,
            ease: 'Power0',
            duration: 500,
            onComplete: () => {
                let delay = 0;
                let delayStep = 10;

                this.sound.play('sfx-multiplier-01');
                this.omegaCoverMultiplier.setTexture(`x${this.request.scenario.multiplier}`);
                this.omegaCover.setTexture('omega_cover');

                if(this.omegaCover.anims.isPlaying) {
                    this.omegaCover.anims.pause();
                }

                this.omegaCover.play('omega_cover_animation');

                this.sound.play('sfx-shuffle');

                for(let i = 8; i < 14; i++) {
                    this.flipShield(this.mainGameItems['your_symbols'][i], 'blue', delay);
                    delay += delayStep;

                    if (i === 10) {
                        this.flipShield(this.mainGameItems['lucky_symbols'][2], 'gold', delay);
                        delay += delayStep;
                    }
                }

                this.flipShield(this.mainGameItems['lucky_symbols'][1], 'gold', delay);
                delay += 100;

                for(let i = 0; i < 8; i++) {
                    this.flipShield(this.mainGameItems['your_symbols'][i], 'blue', delay);
                    delay += delayStep;

                    if (i === 3) {
                        this.flipShield(this.mainGameItems['lucky_symbols'][3], 'gold', delay);
                        delay += delayStep;
                    }
                }

                this.flipShield(this.mainGameItems['lucky_symbols'][0], 'gold', delay);

                delay += 300;

                this.time.delayedCall(delay, () => {
                    this.sound.play('sfx-prepare-main-icon');
                    this.jackpotIndicator.play('jackpot_indicator');
                    this.jackpotIndicatorBase.play('jackpot_indicator_base');

                    this.flipUpSymbol(this.mainGameItems['lucky_symbols'][1], this.request.scenario.lucky_symbols[1], 'gold');
                    this.flipUpSymbol(this.mainGameItems['lucky_symbols'][2], this.request.scenario.lucky_symbols[2], 'gold');

                    this.time.delayedCall(200, () => {
                        this.flipUpSymbol(this.mainGameItems['lucky_symbols'][0], this.request.scenario.lucky_symbols[0], 'gold');
                        this.flipUpSymbol(this.mainGameItems['lucky_symbols'][3], this.request.scenario.lucky_symbols[3], 'gold');

                        this.time.delayedCall(200, () => {
                            this.tweens.add({
                                targets: this.jackpotIndicatorSymbol,
                                scale: 1,
                                ease: 'Power0',
                                duration: 500,
                                delay: 500,
                                onComplete: () => {
                                    for(let i = 0; i < 14; i++) {
                                        let item = this.mainGameItems['your_symbols'][i];
                                        item.setInteractive({ cursor: 'pointer', pixelPerfect: true})
                                            .on('pointerup', () => {
                                                this.openYourSymbol(i, item);
                                            })
                                            .on('pointerover', () => {
                                                item.setTexture('shield_silver_mouseover');

                                                this.sound.play('sfx-coins-light-up-0' + Phaser.Math.RND.integerInRange(1, 4));
                                            })
                                            .on('pointerout', () => {
                                                item.setTexture('shield_blue_flip_down');
                                            });
        
                                        if(i === 13) {
                                            callback();

                                            this.enableIdleTimer();
                                        }    
                                    }
                                }
                            });
                        });
                    });
                });
            }
        });
    }

    enableIdleTimer() {
        this.idleTimer = this.time.addEvent({
            delay: 10000,
            callback: this.shakeUnopenedSymbols,
            callbackScope: this,
            loop: true
        });
    }

    resetIdleTimer() {
        this.stopIdleTimer();
        this.enableIdleTimer();
    }

    stopIdleTimer() {
        if(this.idleTimer) {
            this.idleTimer.remove();
        }
    }

    shakeUnopenedSymbols() {
        for(let i = 0; i < 14; i++) {
            let item = this.mainGameItems['your_symbols'][i];
            
            if(!item.opened) {
                item.inactiveTween = this.tweens.add({
                    targets: [item.inactiveEffect],
                    alpha: 1,
                    duration: Phaser.Math.RND.integerInRange(100, 200),
                    ease: 'Power0',
                    yoyo: true,
                    repeat: 5
                });
            }
        }
    }
    
    openYourSymbol(i, item) {
        if (item.opened || this.bonusRunning || this.winAllRunning) {
            return;
        } 
        
        if( !this.winAllRunning) {
            this.sound.play('sfx-value-reveal-0' + Phaser.Math.RND.integerInRange(1, 5));
        }

        this.stopItemIdle(item);
        
        this.customHelper.removeClickable(item);
        item.opened = true;

        const scenarioItem = this.request.scenario.your_symbols[this.symbolsOpened];
        let flipColor = 'blue';

        if (scenarioItem === 'bonus_symbol') {
            this.bonusRunning = true;
            this.request.reportEvent('bonus_start');
        } else if (scenarioItem === 'bonus_all_symbol') {
            this.winAllRunning = true;
            flipColor = 'gold';
        }

        const symbolOpenedAs = this.symbolsOpened;

        this.yourSymbolsOpeningSequence.push({onScenario:this.symbolsOpened, onBoard:i});
        
        this.flipUpSymbol(item, scenarioItem.symbol ? scenarioItem.symbol : scenarioItem, flipColor, () => {
            if (scenarioItem === 'bonus_symbol') {
                this.shootZeusLightningTo(item.x + this.mainGameGroup.x, item.y + this.mainGameGroup.y);
                item.fronEffect.play('bonus_found_fx');

                store.commit('disableOpenAllButton');

                this.time.delayedCall(1500, () => {
                    this.showBonus();
                });
            } else if (scenarioItem === 'bonus_all_symbol') {
                this.runWinAll(item);
            } else {
                if (scenarioItem.win) {
                    this.shootLightningFromTo(
                        this.mappedLuckies[scenarioItem.symbol].x + this.mainGameGroup.x, 
                        this.mappedLuckies[scenarioItem.symbol].y + this.mainGameGroup.y, 
                        item.x + this.mainGameGroup.x, 
                        item.y + this.mainGameGroup.y);
                        

                    item.fronEffect.play('win_fx_regular');
                    this.mappedLuckies[scenarioItem.symbol].fronEffect.play('win_fx_regular');
                    this.burstCoins(item.x + this.mainGameGroup.x, item.y + this.mainGameGroup.y);
                    
                    this.time.delayedCall(150, () => {
                        item.setTexture(`symbol_light_${scenarioItem.symbol}_flip_down`);
                    });

                    this.openedYourSymbolsLucky.push(item);

                    if (scenarioItem.amount_after) {
                        item.amount_after = General.format_currency(scenarioItem.amount_after).replace(Config.currency.symbol, '');

                        item.amount_add_to_won = scenarioItem.amount_after - scenarioItem.amount;
                    }
                }

                const amount = General.format_currency(scenarioItem.amount).replace(Config.currency.symbol, '');
                item.amount = this.customHelper
                    .createWinningFromSprites(amount, 1, (scenarioItem.win ? '_winnings' : '_regular'), -10)
                    .setX(item.x)
                    .setY(item.y + item.displayHeight / 2 - 30)
                    .setAlpha(0);
    
                this.customHelper.applyDynamicSpriteSize(item.amount, item.displayWidth);
    
                const scaleTo = item.amount.scaleX;
                item.amount.setScale(0);
    
                this.mainGameGroup.add(item.amount);

                if (!scenarioItem.win) {
                    item.greyItem.setTexture(`symbol_${scenarioItem.symbol}_grey`);

                    this.tweens.add({
                        targets: item.greyItem,
                        alpha: 1,
                        duration: 100,
                        ease: 'Power0'
                    });
                }
    
                this.sound.play('sfx-value-point-0' + Phaser.Math.RND.integerInRange(1, 5));

                item.tween = this.tweens.add({
                    targets: [item.amount],
                    scale: scaleTo,
                    alpha: 1,
                    duration: 100,
                    ease: 'Power0',
                    onComplete: () => {
                        if (scenarioItem.win) {
                            this.request.addAmountWon(scenarioItem.amount);
                        }

                        if (symbolOpenedAs === 13) {
                            this.checkForContinueGame();
                        }
                    }
                });
            }
        });

        this.symbolsOpened++;
    }

    runWinAll(item) {
        this.disableYourSymbolsClicks();
        this.stopIdleTimer();
        this.tweens.add({
            targets: this.frontContainerFader,
            alpha: 0.5,
            ease: 'Power0',
            duration: 500
        });

        const symbol = `symbol_gold_${this.request.scenario.win_all_bonus.symbol}_flip_down`;

        this.winAllTempSymbol = this.add.sprite(item.x, item.y, symbol).setScale(item.scaleX, item.scaleY);

        this.frontContainer.add(this.winAllTempSymbol);

        this.sound.play('sfx-special-coin');

        this.tweens.add({
            targets: this.winAllTempSymbol,
            scale: 1,
            ease: Phaser.Math.Easing.Quartic.Out,
            duration: 600,
            onComplete: () => {
                item.setAlpha(0);
                this.tweens.add({
                    targets: this.winAllTempSymbol,
                    x: this.jackpotIndicator.x,
                    y: this.jackpotIndicator.y,
                    ease: Phaser.Math.Easing.Quartic.Out,
                    duration: 1000,
                    onComplete: () => {
                        let tween = this.tweens.add({
                            targets: this.winAllTempSymbol,
                            x: this.jackpotIndicator.x - 5,
                            y: this.jackpotIndicator.y - 5,
                            ease: 'Power0',
                            duration: 50,
                            repeat: -1,
                            yoyo: true,
                        });

                        this.tweens.add({
                            targets: this.winAllTempSymbol,
                            scale: 1.1,
                            ease: 'Power0',
                            duration: 1000
                        });

                        this.time.delayedCall(1400, () => {
                            tween.stop();

                            this.winAllTempSymbol.setX(this.jackpotIndicator.x).setY(this.jackpotIndicator.y);

                            this.tweens.add({
                                targets: this.frontContainerFader,
                                alpha: 0,
                                ease: 'Power0',
                                duration: 100
                            });

                            this.tweens.add({
                                targets: this.winAllTempSymbol,
                                scale: 0.84,
                                ease: 'Power0',
                                duration: 100,
                                onComplete: () => {
                                    this.cameras.main.shake(600, 0.005);

                                    this.sound.play('sfx-multiple-value-turn');

                                    for (let key in this.mainGameItems['your_symbols']) {
                                        if (!this.mainGameItems['your_symbols'][key].opened) {
                                            this.markWinAllWinner(this.mainGameItems['your_symbols'][key])
                                        }
                                    }
                                }
                            });
                        });                

                        this.frontContainer.bringToTop(this.jackpotIndicatorFx);
                        this.jackpotIndicatorFx.play('jackpot_indicator_charge_fx');
                    }
                });
            }
        });
    }

    markWinAllWinner(item) {
        const scenarioItem = this.request.scenario.your_symbols[this.symbolsOpened];

        if (scenarioItem.symbol !== 'bonus_all_symbol') {
            return;
        }

        this.stopItemIdle(item);

        this.shootLightningFromTo(
            this.jackpotIndicator.x + this.frontContainer.x, 
            this.jackpotIndicator.y + this.frontContainer.y, 
            item.x + this.mainGameGroup.x, 
            item.y + this.mainGameGroup.y);

        item.setTexture(`symbol_light_${this.request.scenario.win_all_bonus.symbol}_flip_down`);

        const symbolOpenedAs = this.symbolsOpened;

        this.symbolsOpened++;

        item.fronEffect.play('win_fx_regular');
        this.burstCoins(item.x + this.mainGameGroup.x, item.y + this.mainGameGroup.y);

        this.openedYourSymbolsLucky.push(item);

        const amount = General.format_currency(scenarioItem.amount).replace(Config.currency.symbol, '');
        item.amount = this.customHelper
            .createWinningFromSprites(amount, 1, '_winnings', -10)
            .setX(item.x)
            .setY(item.y + item.displayHeight / 2 - 30)
            .setAlpha(0);

        this.customHelper.applyDynamicSpriteSize(item.amount, 200);

        if (scenarioItem.amount_after) {
            item.amount_after = General.format_currency(scenarioItem.amount_after).replace(Config.currency.symbol, '');

            item.amount_add_to_won = scenarioItem.amount_after - scenarioItem.amount;
        }

        const scaleTo = item.amount.scaleX;
        item.amount.setScale(0);

        this.mainGameGroup.add(item.amount);

        item.tween = this.tweens.add({
            targets: [item.amount],
            scale: scaleTo,
            alpha: 1,
            duration: 50,
            ease: 'Power0',
            onComplete: () => {
                this.request.addAmountWon(scenarioItem.amount);
                
                if (symbolOpenedAs === 13) {
                    this.checkForContinueGame();
                }
            }
        });
    }
 
    showBonus() {
        this.stopIdleTimer();
        this.bonusTweens = [];

        this.sound.play('sfx-bonus-in');

        this.bonusTweens.push(this.tweens.add({
            targets: [this.mainGameGroup, this.frontContainer],
            y: this.cameras.main.height + this.cameras.main.height / 2,
            ease: 'Power0',
            duration: 500
        }));

        if(this.orientationIsSetToPortrait()) {
            this.bonusTweens.push(this.tweens.add({
                targets: this.bonusContainer,
                y: this.cameras.main.centerY - 330,
                ease: Phaser.Math.Easing.Quartic.Out,
                duration: 1000
            }));

            this.bonusTweens.push(this.tweens.add({
                targets: this.zeusPortrait,
                y: this.cameras.main.height + 100,
                ease: Phaser.Math.Easing.Quartic.Out,
                duration: 1000
            }));

            this.bonusTweens.push(this.tweens.add({
                targets: this.templePortrait,
                y: this.cameras.main.height + this.cameras.main.height / 2,
                ease: Phaser.Math.Easing.Quartic.Out,
                duration: 1000
            }));

            this.bonusTweens.push(this.tweens.add({
                targets: [this.cloudLayer5, this.cloudLayer6],
                y: this.cameras.main.height + this.cloudLayer5.height / 2,
                ease: Phaser.Math.Easing.Quartic.Out,
                duration: 1000
            }));
    
            this.bonusTweens.push(this.tweens.add({
                targets: this.cloudLayer1,
                y: 0,
                ease: Phaser.Math.Easing.Quartic.Out,
                duration: 1000
            }));

            this.bonusTweens.push(this.tweens.add({
                targets: this.cloudLayer2,
                y: 800,
                ease: Phaser.Math.Easing.Quartic.Out,
                duration: 1000
            }));

            this.bonusTweens.push(this.tweens.add({
                targets: this.cloudLayer3,
                y: 100,
                ease: Phaser.Math.Easing.Quartic.Out,
                duration: 1000
            }));

            this.bonusTweens.push(this.tweens.add({
                targets: this.cloudLayer4,
                y: 800,
                ease: Phaser.Math.Easing.Quartic.Out,
                duration: 1000
            }));

        } else {
            this.bonusTweens.push(this.tweens.add({
                targets: this.bonusContainer,
                y: this.cameras.main.centerY,
                ease: Phaser.Math.Easing.Quartic.Out,
                duration: 1000
            }));
    
            this.bonusTweens.push(this.tweens.add({
                targets: this.cloudLayer1,
                y: 0,
                ease: Phaser.Math.Easing.Quartic.Out,
                duration: 1000
            }));

            this.bonusTweens.push(this.tweens.add({
                targets: this.cloudLayer2,
                y: 400,
                ease: Phaser.Math.Easing.Quartic.Out,
                duration: 1000
            }));

            this.bonusTweens.push(this.tweens.add({
                targets: this.cloudLayer3,
                y: 50,
                ease: Phaser.Math.Easing.Quartic.Out,
                duration: 1000
            }));

            this.bonusTweens.push(this.tweens.add({
                targets: this.cloudLayer4,
                y: 50,
                ease: Phaser.Math.Easing.Quartic.Out,
                duration: 1000
            }));
        }

        this.tweens.add({
            targets: this.bonusDarkFader,
            alpha: 0.4,
            ease: Phaser.Math.Easing.Quartic.Out,
            duration: 1000,
            onComplete: () => {
                this.bonusTweens = [];
                for(let i = 0; i < 10; i++) {
                    let item = this.bonusItems[i];

                    item.setInteractive({ cursor: 'pointer', pixelPerfect: true})
                        .on('pointerup', () => {
                            this.openBonusSymbol(item);
                        })
                        .on('pointerover', () => {
                            item.hoverTween = this.tweens.add({
                                targets: item,
                                scale: 0.9,
                                ease: 'Power0',
                                duration: 100,
                            });
                            this.stopItemIdle(item);
                        })
                        .on('pointerout', () => {
                            if (item.hoverTween && item.hoverTween.isPlaying) {
                                item.hoverTween.stop();
                            }

                            item.hoverTween = this.tweens.add({
                                targets: item,
                                scale: 1,
                                ease: 'Power0',
                                duration: 100,
                            });
                        });
                }

                this.tweens.add({
                    targets: [this.mainSound, this.mainAmbSound],
                    volume: 0,
                    duration: 500,
                    onComplete: () => {
                        this.mainSound.stop();
                        this.mainAmbSound.stop()
                    }
                });
        
                this.bonusSound.play();
                this.bonusAmbSound.play();

                this.tweens.add({
                    targets: [this.bonusSound, this.bonusAmbSound],
                    volume: 1,
                    duration: 500,
                });

                store.commit('hideOpenAllButton');
                store.commit('showCustomPlayButton', 'icon_open-all.svg');
            }
        });
    }

    stopItemIdle(item) {
        if(item.inactiveTween && item.inactiveTween.isPlaying()) {
            item.inactiveTween.stop();
            item.inactiveEffect.setAlpha(0);
        }
    }

    customPlayButtonEvent() {
        for (let i = this.bonusSymbolsOpened; i < this.request.scenario.bonus.luckies.length; i++) {
            let scenarioItem = this.request.scenario.bonus.luckies[i];

            for (let [index, item] of Object.entries(this.bonusItems)) {
                if(!item.opened) {
                    this.openBonusSymbol(item);
                    if (!scenarioItem) {
                        store.commit('disableCustomPlayButton');
                        return;
                    }

                    if (Config.assets.settings.disable_open_all_bonus) {
                        return;
                    }
                }
            }

        }
    }

    openBonusSymbol(item) {
        if (item.opened || this.allNeededBonusItemsOpened) {
            return;
        }

        this.customHelper.removeClickable(item);

        if (item.hoverTween && item.hoverTween.isPlaying) {
            item.hoverTween.stop();
        }

        item.setScale(1);

        item.opened = true;
        const scenarioItem = this.request.scenario.bonus.luckies[this.bonusSymbolsOpened];

        this.shootZeusLightningTo(item.x + this.bonusContainer.x, item.y + this.bonusContainer.y);
        
        this.sound.play('sfx-bonus-reveal-0' + Phaser.Math.RND.integerInRange(1, 3));
        item.play('bonus_token_smash');
        item.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
            item.setVisible(0);
        });
        
        if (scenarioItem) {
            const amount = General.format_currency(scenarioItem).replace(Config.currency.symbol, '');
            let flamesContainer = this.addAmountFlames(item, amount);

            item.amount = this.customHelper
                .createWinningFromSprites(amount, 1, '_bonus_winnings', -20)
                .setX(item.x)
                .setY(item.y)
                .setAlpha(0);

            this.bonusContainer.add(flamesContainer);
            this.bonusContainer.add(item.amount);

            this.bonusContainer.bringToTop(item);
            flamesContainer.setAlpha(1);
            item.amount.setAlpha(1);

            this.request.addAmountWon(scenarioItem);
            this.customHelper.applyDynamicSpriteSize(item.amount, 200);

            flamesContainer.setScale(item.amount.scaleX, item.amount.scaleY);
            flamesContainer.setX(item.x).setY((item.amount.y + item.amount.displayHeight / 2) - flamesContainer.displayHeight / 2);
            item.flamesContainer = flamesContainer;

            this.time.delayedCall(200, () => {
                this.sound.play('sfx-bonus-point-reveal-0' + Phaser.Math.RND.integerInRange(1, 3));
            });

            if (this.bonusSymbolsOpened+1 === 10) {
                this.time.delayedCall(2500, () => {
                    this.backToMainGame();
                });        
            }

        } else {
            this.allNeededBonusItemsOpened = true;
            this.disableBonusClicks();
            item.amount = this.add.sprite(item.x, item.y, 'medusa_head').setAlpha(0);

            this.bonusContainer.add(item.amount);
            this.bonusContainer.bringToTop(item);
            item.amount.setAlpha(1);

            item.amount.play('medusa_head');

            this.time.delayedCall(600, () => {
                this.sound.play('sfx-medusa');
            });

            this.time.delayedCall(800, () => {
                this.showNotWonBonusItems();
            });                
        }

        this.bonusSymbolsOpened++;
    }

    disableBonusClicks() {
        for(let i = 0; i < 10; i++) {
            let item = this.bonusItems[i];

            this.customHelper.removeClickable(item);
        }
    }

    disableYourSymbolsClicks() {
        for(let i = 0; i < 14; i++) {
            let item = this.mainGameItems['your_symbols'][i];

            this.customHelper.removeClickable(item);
        }
    }

    showNotWonBonusItems() {
        let unluckiesOpened = 0;

        if (!this.request.scenario.bonus.unluckies) {
            this.time.delayedCall(2500, () => {
                this.backToMainGame();
            });        
        }

        this.sound.play('sfx-bonus-freeze');

        this.time.delayedCall(1000, () => {
            this.sound.play('sfx-bonus-crack');
        });     

        for(let i = 0; i < 10; i++) {
            let item = this.bonusItems[i];
            
            if (!item.opened) {
                item.play('bonus_token_to_stone_' + Phaser.Math.RND.integerInRange(1, 3));

                const scenarioItem = this.request.scenario.bonus.unluckies[unluckiesOpened];

                const amount = General.format_currency(scenarioItem).replace(Config.currency.symbol, '');
    
                item.amount = this.customHelper
                    .createWinningFromSprites(amount, 1, '_bonus_loosing', -20)
                    .setX(item.x)
                    .setY(item.y)
                    .setAlpha(0);
    
                this.bonusContainer.add(item.amount);
    
                item.amount.setAlpha(1);
        
                this.customHelper.applyDynamicSpriteSize(item.amount, item.displayWidth);

                const scaleTo = item.amount.scaleX;
                item.amount.setScale(0);

                this.tweens.add({
                    targets: item.amount,
                    scale: scaleTo,
                    delay: 1000,
                    ease: 'Power0',
                    duration: 200,
                    onComplete: unluckiesOpened === this.request.scenario.bonus.unluckies.length-1 ? () => {
                        this.time.delayedCall(1000, () => {
                            this.backToMainGame();
                        });                
                    } : false
                });

                unluckiesOpened++;
            }
        }
    }

    backToMainGame() {
        this.sound.play('sfx-bonus-out');

        store.commit('hideCustomPlayButton');
        this.bonusRunning = false;
        this.request.reportEvent('bonus_end');

        this.bonusTweens.push(this.tweens.add({
            targets: this.bonusContainer,
            y: this.bonusContainer.currentOriginY,
            ease: 'Power0',
            duration: 500
        }));

        this.bonusTweens.push(this.tweens.add({
            targets: [this.mainGameGroup, this.frontContainer],
            y: this.mainGameGroup.currentOriginY,
            ease: Phaser.Math.Easing.Quartic.Out,
            duration: 1000
        }));

        this.bonusTweens.push(this.tweens.add({
            targets: this.cloudLayer1,
            y: this.cloudLayer1.currentOriginY,
            ease: Phaser.Math.Easing.Quartic.Out,
            duration: 1000
        }));

        this.bonusTweens.push(this.tweens.add({
            targets: this.cloudLayer2,
            y: this.cloudLayer2.currentOriginY,
            ease: Phaser.Math.Easing.Quartic.Out,
            duration: 1000
        }));

        this.bonusTweens.push(this.tweens.add({
            targets: this.cloudLayer3,
            y: this.cloudLayer3.currentOriginY,
            ease: Phaser.Math.Easing.Quartic.Out,
            duration: 1000
        }));

        this.bonusTweens.push(this.tweens.add({
            targets: this.cloudLayer4,
            y: this.cloudLayer4.currentOriginY,
            ease: Phaser.Math.Easing.Quartic.Out,
            duration: 1000
        }));

        if(this.cloudLayer5.currentOriginY) {
            this.bonusTweens.push(this.tweens.add({
                targets: this.cloudLayer5,
                y: this.cloudLayer5.currentOriginY,
                ease: Phaser.Math.Easing.Quartic.Out,
                duration: 1000
            }));
        }

        if(this.cloudLayer6.currentOriginY) {
            this.bonusTweens.push(this.tweens.add({
                targets: this.cloudLayer6,
                y: this.cloudLayer6.currentOriginY,
                ease: Phaser.Math.Easing.Quartic.Out,
                duration: 1000
            }));
        }

        if(this.zeusPortrait.currentOriginY) {
            this.bonusTweens.push(this.tweens.add({
                targets: this.zeusPortrait,
                y: this.zeusPortrait.currentOriginY,
                ease: Phaser.Math.Easing.Quartic.Out,
                duration: 1000
            }));
        }

        if(this.templePortrait.currentOriginY) {
            this.bonusTweens.push(this.tweens.add({
                targets: this.templePortrait,
                y: this.templePortrait.currentOriginY,
                ease: Phaser.Math.Easing.Quartic.Out,
                duration: 1000
            }));
        }

        this.tweens.add({
            targets: this.bonusDarkFader,
            alpha: 0,
            ease: Phaser.Math.Easing.Quartic.Out,
            duration: 1000,
            onComplete: () => {
                this.tweens.add({
                    targets: [this.bonusSound, this.bonusAmbSound],
                    volume: 0,
                    duration: 500,
                    onComplete: () => {
                        this.bonusSound.stop();
                        this.bonusAmbSound.stop()
                    }
                });
        
                this.mainSound.play();
                this.mainAmbSound.play();

                this.tweens.add({
                    targets: [this.mainSound, this.mainAmbSound],
                    volume: 0.5,
                    duration: 500,
                });

                this.bonusTweens = [];
                this.checkForContinueGame();
            }
        });
    }

    addAmountFlames(item, amount) {
        let flamesContainer = this.add.container().setAlpha(0);
        let offsetX = 0;
        let amountSymbolsCount = String(amount).trim();
        let items = [];
        let flame;
        let delay = 0;

        for (let i = 0; i < amountSymbolsCount.length; i++) {
            switch(amountSymbolsCount[i]) {
                case '.':
                case ',':
                    offsetX = 15;
                    break;
                    
                default: 
                    flame = this.add.sprite(flame ? flame.x + flame.width / 2 + offsetX: 0, 0, 'win_flames');
                        flamesContainer.add(flame);
                        this.startFlameAfterDelay(flame, delay);
                    offsetX = 0;
                    items.push(flame);
                    delay += 200;

                    if (delay > 500) {
                        delay = 0;
                    }
            }
        }


        let minusOffsetX = flame.x / 2;
        let minusOffsetY = flame.y / 2;

        items.forEach((value) => {
            value.x -= minusOffsetX;
            value.y -= minusOffsetY;
        });

        let width = (items[items.length-1].x + items[items.length-1].width / 2) - (items[0].x - items[0].width / 2)

        flamesContainer.setSize(width, flame.height);

        item.flamesContainer = flamesContainer;

        return flamesContainer;
    }
    
    startFlameAfterDelay(flame, delay) {
        this.time.delayedCall(delay, () => {
            flame.play('win_flames');
        });                
    }

    createGameItems() {
        this.mainGameItems = {'lucky_symbols':{}, 'your_symbols':{}};

        this.jackpotIndicator = this.add.sprite(3, -10, 'jackpot_indicator');
        this.jackpotIndicatorBase = this.add.sprite(this.jackpotIndicator.x, this.jackpotIndicator.y, 'jackpot_indicator_base');
        this.jackpotIndicatorSymbol = this.add.sprite(this.jackpotIndicator.x, this.jackpotIndicator.y, '');
        this.jackpotIndicatorFx = this.add.sprite(this.jackpotIndicator.x, this.jackpotIndicator.y, 'jackpot_indicator_charge_fx').setVisible(false);

        this.frontContainerFader = this.add.graphics().fillStyle(0x000000, 1).fillRect(0, 0, 2500, 2500).setAlpha(0);
        this.frontContainer.add(this.frontContainerFader);
        this.frontContainer.add(this.jackpotIndicatorBase);
        this.frontContainer.add(this.jackpotIndicatorSymbol);
        this.frontContainer.add(this.jackpotIndicatorFx);
        this.frontContainer.add(this.jackpotIndicator);

        let animationConfig = {
            key: 'jackpot_indicator',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNumbers('jackpot_indicator', {
                start: 0,
                end: 30,
            }),
            frameRate: 25
        };
        this.anims.create(animationConfig);

        animationConfig = {
            key: 'jackpot_indicator_close',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNumbers('jackpot_indicator_close', {
                start: 0,
                end: 17,
            }),
            frameRate: 25
        };
        this.anims.create(animationConfig);

        animationConfig = {
            key: 'jackpot_indicator_base',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNumbers('jackpot_indicator_base', {
                start: 0,
                end: 48,
            }),
            frameRate: 25,
            repeat: -1
        };
        this.anims.create(animationConfig);

        animationConfig = {
            key: 'jackpot_indicator_charge_fx',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('jackpot_indicator_charge_fx',
            {
                prefix: 'Charge_FX_',
                start: 0,
                end: 48,
                suffix: '.png',
                zeroPad: 4
            }),
            frameRate: 25,
            showOnStart: true,
            hideOnComplete: true
        };

        this.anims.create(animationConfig);

        animationConfig = {
            key: 'win_fx_regular',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('win_fx_regular',
            {
                prefix: 'Win_FX_',
                start: 0,
                end: 52,
                suffix: '.png',
                zeroPad: 4
            }),
            frameRate: 25,
            showOnStart: true,
            hideOnComplete: true
        };

        this.anims.create(animationConfig);

        let startX = -(this.mainFrame.width / 2) + 124;
        let y = -10;

        for(let i = 0; i < 4; i++) {
            let item = this.add.sprite(startX, y, 'shield_gold_flip_down').setScale(0.72);
            
            this.mainGameGroup.add(item);
            item.fronEffect = this.add.sprite(item.x, item.y, 'win_fx_regular').setScale(0.72).setVisible(0);
            this.mainGameGroup.add(item.fronEffect);
            this.mainGameItems['lucky_symbols'][i] = item;

            startX += i === 1 ? 460 : 204;
        }

        this.defineYourNumbersCoors();

        for (let symbol of Config.symbols) {
            for (let color of ['blue', 'gold', 'light']) {
                for (let position of ['flip_up', 'flip_down']) {
                    let key = `symbol_${color}_${symbol}_${position}`;
                    let animationConfig = {
                        key: key,
                        skipMissedFrames: true,
                        frames: this.anims.generateFrameNumbers(key, {
                            start: 0,
                            end: position === 'flip_down' ? 2 : 13,
                        }),
                        frameRate: 25
                    };
                    this.anims.create(animationConfig);
                }
            }
        }
        
        for (let position of ['flip_up', 'flip_down']) {
            let key = `symbol_blue_bonus_symbol_${position}`;
            let animationConfig = {
                key: key,
                skipMissedFrames: true,
                frames: this.anims.generateFrameNumbers(key, {
                    start: 0,
                    end: position === 'flip_down' ? 2 : 13,
                }),
                frameRate: 25
            };
            this.anims.create(animationConfig);
        }

        for (let color of ['blue', 'gold']) {
            for (let position of ['flip_up', 'flip_down']) {
                let key = `shield_${color}_${position}`;
                let animationConfig = {
                    key: key,
                    skipMissedFrames: true,
                    frames: this.anims.generateFrameNumbers(key, {
                        start: 0,
                        end: position === 'flip_down' ? 2 : 13,
                    }),
                    frameRate: 25
                };
                this.anims.create(animationConfig);
            }
        }
        for(let i = 0; i < 14; i++) {
            let item = this.add.sprite(this.yourNumbersCoors[i].x, this.yourNumbersCoors[i].y, 'shield_blue_flip_down').setScale(0.66);
            this.mainGameGroup.add(item);
            item.greyItem = this.add.sprite(item.x, item.y, '').setScale(0.66).setAlpha(0);
            this.mainGameGroup.add(item.greyItem);
            item.fronEffect = this.add.sprite(item.x, item.y, 'win_fx_regular').setScale(0.66).setVisible(0);
            this.mainGameGroup.add(item.fronEffect);
            item.absoluteIndex = i;
            item.inactiveEffect = this.add.sprite(item.x, item.y, 'shield_silver_mouseover').setScale(0.66).setAlpha(0);
            this.mainGameGroup.add(item.inactiveEffect);
            this.mainGameItems['your_symbols'][i] = item;
        }
    }

    createBonus() {
        this.bonusContainer = this.add.container();

        let i = 0;
        let startY = -270;
        this.bonusItems = {};

        for (let [index, count] of [3, 4, 3].entries()) {
            let startX = count === 3 ? -250 : -370;

            for (let k = 0; k < count; k++) {
                let offsetY = 0;

                if(count === 3 && k === 1) {
                    offsetY = index === 0 ? -100 : 100;
                }

                let item = this.add.sprite(startX, startY + offsetY, 'bonus_token');
                this.bonusContainer.add(item);
            
                this.bonusItems[i] = item;

                startX += 250;

                i++;
            }

            startY += 250;
        }

        let animationConfig = {
            key: 'bonus_token_smash',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('bonus_token_smash',
            {
                prefix: 'Bonus_Token_Smash_',
                start: 0,
                end: 24,
                suffix: '.png',
                zeroPad: 4,
                showOnStart: true,
                hideOnComplete: true
            }),
            frameRate: 25,
        };

        this.anims.create(animationConfig);

        animationConfig = {
            key: 'medusa_head',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('medusa_head',
            {
                prefix: 'Medusa_Head_',
                start: 0,
                end: 65,
                suffix: '.png',
                zeroPad: 4
            }),
            frameRate: 25,
        };

        this.anims.create(animationConfig);

        animationConfig = {
            key: 'win_flames',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('win_flames',
            {
                prefix: 'Win_Flames_',
                start: 0,
                end: 49,
                suffix: '.png',
                zeroPad: 4
            }),
            frameRate: 25,
            repeat: -1
        };

        this.anims.create(animationConfig);

        for (let i = 1; i <= 3; i++) {
            animationConfig = {
                key: `bonus_token_to_stone_${i}`,
                skipMissedFrames: true,
                frames: this.anims.generateFrameNames(`bonus_token_to_stone_${i}`,
                {
                    prefix: `Bonus_Token_to_Stone_0${i}_`,
                    start: 0,
                    end: 35,
                    suffix: '.png',
                    zeroPad: 4
                }),
                frameRate: 25
            };
    
            this.anims.create(animationConfig);
        } 
    }

    createLightnings() {
        this.zeusLightning = this.add.sprite(0, 0, 'zeus_lightning').setOrigin(0, 0.5).setVisible(false);
        this.lightningShort = this.add.sprite(0, 0, 'lightning_short').setOrigin(0, 0.5).setVisible(false);
        this.lightningMedium = this.add.sprite(0, 0, 'lightning_medium').setOrigin(0, 0.5).setVisible(false);
        this.lightningLong = this.add.sprite(0, 0, 'lightning_long').setOrigin(0, 0.5).setVisible(false);

        this.lightningShort.animationName = 'lightning_short';
        this.lightningMedium.animationName = 'lightning_medium';
        this.lightningLong.animationName = 'lightning_long';

        let animationConfig = {
            key: 'zeus_lightning',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('zeus_lightning',
            {
                prefix: 'Zeus_Bonus_Lightning_FX_',
                start: 0,
                end: 12,
                suffix: '.png',
                zeroPad: 4
            }),
            frameRate: 25,
            showOnStart: true,
            hideOnComplete: true
        };

        this.anims.create(animationConfig);

        animationConfig = {
            key: 'lightning_long',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('lightning_long',
            {
                prefix: 'Lightning_Long_',
                start: 0,
                end: 12,
                suffix: '.png',
                zeroPad: 4
            }),
            frameRate: 25,
            showOnStart: true,
            hideOnComplete: true
        };

        this.anims.create(animationConfig);


        animationConfig = {
            key: 'lightning_medium',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('lightning_medium',
            {
                prefix: 'Lightning_Medium_',
                start: 0,
                end: 12,
                suffix: '.png',
                zeroPad: 4
            }),
            frameRate: 25,
            showOnStart: true,
            hideOnComplete: true
        };

        this.anims.create(animationConfig);

        animationConfig = {
            key: 'lightning_short',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('lightning_short',
            {
                prefix: 'Lightning_Short_',
                start: 0,
                end: 12,
                suffix: '.png',
                zeroPad: 4
            }),
            frameRate: 25,
            showOnStart: true,
            hideOnComplete: true
        };

        this.anims.create(animationConfig);

        animationConfig = {
            key: 'bonus_found_fx',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('bonus_found_fx',
            {
                prefix: 'Bonus_Win_FX_',
                start: 0,
                end: 20,
                suffix: '.png',
                zeroPad: 4
            }),
            frameRate: 25,
            showOnStart: true,
            hideOnComplete: true
        };

        this.anims.create(animationConfig);
    }

    checkForContinueGame() {
        if(this.symbolsOpened === 14) {
            store.commit('disableOpenAllButton');
            if(this.request.scenario.multiplier > 1 && !this.multiplierFinished && this.openedYourSymbolsLucky.length) {
                this.showMultiplier();
            } else {
                this.time.delayedCall(1000, () => {
                    this.finishGame();
                });
            }

            this.stopIdleTimer();
        } else {
            this.resetIdleTimer();
            store.commit('showOpenAllButton');
        }
    }

    finishGame() {
        this.tweens.add({
            targets: [this.mainSound, this.mainAmbSound],
            volume: 1,
            duration: 500,
        });

        if(this.request.scenario.total_prize > 0) {
            const ratio = this.request.scenario.total_prize / this.request.ticketAmount;

            if(ratio >= Config.assets.ratios.big_win) {
                this.showBigWin();
            } else {
                this.showRegularWin();
            }
        } else {
            this.fadeInMainFader();
            this.ticketFinished();
        }
    }

    createFader() {
        this.fullFaderMain = this.add.graphics().fillStyle(0x000000, 1).fillRect(0, 0, 1920, 1920);
        this.fullFaderMain.setAlpha(0.4);
    }

    fadeInMainFader(alpha) {
        this.children.bringToTop(this.fullFaderMain);
        this.tweens.add({
            targets: this.fullFaderMain,
            alpha: alpha ? alpha : 0.4,
            ease: 'Power0',
            duration: 500
        });
    }

    showRegularWin() {
        this.regularWinDestroyed = false;
        this.regularWinContainer = this.add.container();
        this.regularWinContainer.setAlpha(0);
        this.fadeInMainFader(0.4);
        this.children.bringToTop(this.regularWinContainer);

        this.regularWinLightningMediumLeft = this.add.sprite(0, 0, 'lightning_medium').setOrigin(0, 0.5).setVisible(false);
        this.regularWinContainer.add(this.regularWinLightningMediumLeft);
        this.regularWinLightningMediumRight = this.add.sprite(0, 0, 'lightning_medium').setOrigin(1, 0.5).setVisible(false);
        this.regularWinLightningMediumRight.flipX = true;
        this.regularWinContainer.add(this.regularWinLightningMediumRight);

        this.regularWinLightningShortLeft1 = this.add.sprite(0, 0, 'lightning_short').setOrigin(0, 0.5).setVisible(false).setAngle(-30);
        this.regularWinLightningShortLeft1.flipY = true;
        this.regularWinContainer.add(this.regularWinLightningShortLeft1);
        this.regularWinLightningShortLeft2 = this.add.sprite(0, 0, 'lightning_short').setOrigin(0, 0.5).setVisible(false).setAngle(30);
        this.regularWinContainer.add(this.regularWinLightningShortLeft2);

        this.regularWinLightningShortRight1 = this.add.sprite(0, 0, 'lightning_short').setOrigin(1, 0.5).setVisible(false).setAngle(30);
        this.regularWinLightningShortRight1.flipX = true;
        this.regularWinLightningShortRight1.flipY = true;
        this.regularWinContainer.add(this.regularWinLightningShortRight1);
        this.regularWinLightningShortRight2 = this.add.sprite(0, 0, 'lightning_short').setOrigin(1, 0.5).setVisible(false).setAngle(-30);
        this.regularWinLightningShortRight2.flipX = true;
        this.regularWinContainer.add(this.regularWinLightningShortRight2);
        this.regularWinAmountContainer = this.customHelper.createWinningFromSprites(General.format_currency(this.request.scenario.total_prize).replace(Config.currency.symbol, ''), 1, '_winning_counter', -10);
        this.regularWinContainer.add(this.regularWinAmountContainer);
        this.customHelper.applyDynamicSpriteSize(this.regularWinAmountContainer, 600);

        let scaleTo = this.regularWinAmountContainer.scaleX;

        this.regularWinAmountContainer.setScale(0);
        this.regularWinPositioner();
        this.tweens.add({
            targets: this.regularWinContainer,
            alpha: 1,
            ease: 'Power0',
            duration: 500,
            onComplete: () => {
                this.sound.play('sfx-win');
                this.regularWinTween = this.tweens.add({
                    targets: [this.regularWinAmountContainer],
                    scale: scaleTo,
                    ease: Phaser.Math.Easing.Quintic.In,
                    duration: 700,
                    onComplete: () => {
                        this.cameras.main.shake(300, 0.001);

                        let repeatTimes = 1;

                        this.regularWinTimer = this.time.delayedCall(200, () => {
                            this.regularWinLightningMediumLeft.play({key: 'lightning_medium', repeat: repeatTimes});
                        });

                        this.regularWinLightningMediumRight.play({key: 'lightning_medium', repeat: repeatTimes});
                        this.regularWinLightningShortLeft1.play({key: 'lightning_short', repeat: repeatTimes});
                        this.regularWinLightningShortRight1.play({key: 'lightning_short', repeat: repeatTimes});
                        this.regularWinLightningShortLeft2.play({key: 'lightning_short', repeat: repeatTimes});
                        this.regularWinLightningShortRight2.play({key: 'lightning_short', repeat: repeatTimes});

                        this.regularWinContainer.setInteractive({ cursor: 'pointer'})
                        .once('pointerup', () => {
                            this.destroyRegularWin();
                        });

                        this.regularWinTimer = this.time.delayedCall(2000, () => {
                           this.destroyRegularWin();
                        });
                    }
                });
            }
        });
    }

    regularWinPositioner() {
        if(!this.regularWinContainer) {
            return;
        }

        this.regularWinContainer.x = this.cameras.main.centerX;
        this.regularWinContainer.y = this.cameras.main.centerY;
        this.regularWinContainer.setSize(this.cameras.main.width, this.cameras.main.height);

        this.regularWinLightningMediumLeft.setX(-960 - 40);
        this.regularWinLightningMediumRight.setX(960 + 40);

        let shortOffset = 165;

        this.regularWinLightningShortLeft1.setX(this.regularWinLightningMediumLeft.x + this.regularWinLightningMediumLeft.width - shortOffset).setY(this.regularWinLightningMediumLeft.y);
        this.regularWinLightningShortRight1.setX((this.regularWinLightningMediumRight.x - this.regularWinLightningMediumRight.width) + shortOffset).setY(this.regularWinLightningMediumRight.y);

        this.regularWinLightningShortLeft2.setX(this.regularWinLightningShortLeft1.x).setY(this.regularWinLightningShortLeft1.y);
        this.regularWinLightningShortRight2.setX(this.regularWinLightningShortRight1.x).setY(this.regularWinLightningShortRight1.y);

        this.regularWinAmountContainer.setY(0);
    }

    destroyRegularWin() {
        if (this.regularWinDestroyed) {
            return;
        }

        this.regularWinDestroyed = true;

        this.customHelper.removeClickable(this.regularWinContainer);

        if(this.regularWinTimer) {
            this.regularWinTimer.remove();
        }
        this.tweens.add({
            targets: [this.regularWinContainer],
            scale: 0,
            ease: 'Power0',
            duration: 300,
            onComplete: () => {
                if(this.regularWinTween && this.regularWinTween.isPlaying()) {
                    this.regularWinTween.stop();
                    this.regularWinTween.remove();
                }
                
                if(this.regularWinContainer) {
                    this.regularWinContainer.destroy();
                }

                if(this.regularWinAmountContainer) {
                    this.regularWinAmountContainer.destroy();
                }

                this.ticketFinished();
            }
        });
    }

    showBigWin() {
        this.bigWinDestroyed = false;
        this.bigWinContainer = this.add.container();
        this.bigWinContainer.setAlpha(0);
        this.bigWinLightsContainer = this.add.container();

        this.leafRing = this.add.sprite(0, 0, 'leaf_ring').setScale(0);
        this.bigWinContainer.add(this.leafRing);

        this.bwLightningShort1 = this.add.sprite(0, 0, 'lightning_short').setOrigin(0.5, 0.5).setAngle(-10).setVisible(false);
        this.bwLightningShort1.flipY = true;
        this.bigWinLightsContainer.add(this.bwLightningShort1);
        this.bwLightningShort2 = this.add.sprite(0, 0, 'lightning_short').setOrigin(0.5, 0.5).setVisible(false);
        this.bigWinLightsContainer.add(this.bwLightningShort2);
        this.bwLightningShort3 = this.add.sprite(0, 0, 'lightning_short').setOrigin(0.5, 0.5).setAngle(-100).setVisible(false);
        this.bwLightningShort3.flipY = true;
        this.bigWinLightsContainer.add(this.bwLightningShort3);
        this.bwLightningShort4 = this.add.sprite(0, 0, 'lightning_short').setOrigin(0.5, 0.5).setAngle(-90).setVisible(false);
        this.bigWinLightsContainer.add(this.bwLightningShort4);

        this.bwLightningLong1 = this.add.sprite(0, 0, 'lightning_long').setOrigin(0.5, 1).setAngle(22).setVisible(false);
        this.bigWinLightsContainer.add(this.bwLightningLong1);
        this.bwLightningLong2 = this.add.sprite(0, 0, 'lightning_long').setOrigin(0.5, 1).setAngle(-20).setVisible(false);
        this.bwLightningLong2.flipX = true;
        this.bigWinLightsContainer.add(this.bwLightningLong2);
        this.bwLightningLong3 = this.add.sprite(0, 0, 'lightning_long').setOrigin(0.5, 0).setAngle(30).setVisible(false);
        this.bwLightningLong3.flipX = true;
        this.bigWinLightsContainer.add(this.bwLightningLong3);

        this.bwLightningMedium1 = this.add.sprite(0, 0, 'lightning_medium').setOrigin(0.5, 1).setVisible(false);
        this.bigWinLightsContainer.add(this.bwLightningMedium1);

        this.bwLightningMedium2 = this.add.sprite(0, 0, 'lightning_medium').setOrigin(0.5, 1).setVisible(false);
        this.bwLightningMedium2.flipX = true;
        this.bigWinLightsContainer.add(this.bwLightningMedium2);

        this.bwLightningMedium3 = this.add.sprite(0, 0, 'lightning_medium').setOrigin(0.5, 1).setAngle(-22).setVisible(false);
        this.bigWinLightsContainer.add(this.bwLightningMedium3);

        this.bwLightningShort5 = this.add.sprite(0, 0, 'lightning_short').setOrigin(0.5, 0.5).setAngle(-90).setVisible(false);
        this.bigWinLightsContainer.add(this.bwLightningShort5);
        this.bwLightningShort6 = this.add.sprite(0, 0, 'lightning_short').setOrigin(0.5, 0.5).setAngle(-70).setVisible(false);
        this.bigWinLightsContainer.add(this.bwLightningShort6);
        this.bwLightningShort7 = this.add.sprite(0, 0, 'lightning_short').setOrigin(0.5, 0.5).setAngle(-70).setVisible(false);
        this.bigWinLightsContainer.add(this.bwLightningShort7);
        this.bwLightningShort8 = this.add.sprite(0, 0, 'lightning_short').setOrigin(0.5, 0.5).setAngle(-50).setVisible(false);
        this.bigWinLightsContainer.add(this.bwLightningShort8);

        this.bigWinContainer.add(this.bigWinLightsContainer);

        this.bigWinTitle = this.add.sprite(0, 0, 'big_win_txt').setOrigin(0.5, 1).setScale(0);

        let checkerSizes = this.customHelper.createWinningFromSprites(General.format_currency(this.request.scenario.total_prize).replace(Config.currency.symbol, ''), 1, '_winning_counter', -10).setAlpha(0);
        this.customHelper.applyDynamicSpriteSize(checkerSizes, 700);

        this.bigWinAmountContainer = this.customHelper.createWinningFromSprites(General.format_currency(0).replace(Config.currency.symbol, ''), 1, '_winning_counter', -10).setScale(checkerSizes.scaleX).setAlpha(0);
        checkerSizes.destroy();

        this.bigWinContainer.add(this.bigWinTitle);
        this.bigWinContainer.add(this.bigWinAmountContainer);

        this.bigWinPositioner();
        this.bigWinTitle.setScale(0);
        
        this.fadeInMainFader(0.4);
        
        this.children.bringToTop(this.bigWinContainer);
        this.sound.play('stg-bigwin');
        this.tweens.add({
            targets: this.bigWinContainer,
            alpha: 1,
            ease: 'Power0',
            duration: 300,
            onComplete: () => {
                this.bigWinLeafRingTween = this.tweens.add({
                    targets: [this.leafRing],
                    scale: 1,
                    ease: Phaser.Math.Easing.Quintic.In,
                    duration: 500,
                    onComplete: () => {
                        let repeatTimes = 5;

                        this.bwLightningShort5.play({key: 'lightning_short', repeat: repeatTimes});
                        this.bwLightningShort2.play({key: 'lightning_short', repeat: repeatTimes});
                        this.bwLightningShort3.play({key: 'lightning_short', repeat: repeatTimes});
                        this.bwLightningShort4.play({key: 'lightning_short', repeat: repeatTimes});
                        this.bwLightningMedium2.play({key: 'lightning_medium', repeat: repeatTimes});
                        this.bwLightningShort8.play({key: 'lightning_short', repeat: repeatTimes});

                        this.time.delayedCall(200, () => {
                            this.bwLightningShort1.play({key: 'lightning_short', repeat: repeatTimes});
                            this.bwLightningShort6.play({key: 'lightning_short', repeat: repeatTimes});
                            this.bwLightningShort7.play({key: 'lightning_short', repeat: repeatTimes});
                            this.bwLightningMedium1.play({key: 'lightning_medium', repeat: repeatTimes});
                        });

                        this.time.delayedCall(300, () => {
                            this.bwLightningLong1.play({key: 'lightning_long', repeat: repeatTimes});
                            this.bwLightningLong2.play({key: 'lightning_long', repeat: repeatTimes});
                            this.bwLightningLong3.play({key: 'lightning_long', repeat: repeatTimes});
                            this.bwLightningMedium3.play({key: 'lightning_medium', repeat: repeatTimes});
                        });

                        this.cameras.main.shake(350, 0.001);

                        this.bigWinLeafRingTween = this.tweens.add({
                            targets: [this.leafRing],
                            angle: 360,
                            ease: 'Power0',
                            duration: 15000,
                            repeat: -1
                        });
                    }
                });

                this.bigWinTween = this.tweens.add({
                    targets: [this.bigWinTitle],
                    scale: 1,
                    ease: Phaser.Math.Easing.Quintic.In,
                    duration: 500,
                    delay: 300,
                    onComplete: () => {

                        this.bigWinContainer.setInteractive({ cursor: 'pointer'})
                        .once('pointerup', () => {
                            this.destroyBigWin();
                        });

                        this.bigWinAmountContainer.setAlpha(1);
        
                        this.incrementTo(this.request.scenario.total_prize);
                    }
                });
            }
        });
    }

    destroyBigWin() {
        if (this.bigWinDestroyed) {
            return;
        }

        this.bigWinDestroyed = true;

        this.customHelper.removeClickable(this.bigWinContainer);
        
        this.tweens.add({
            targets: [this.bigWinContainer],
            scale: 0,
            ease: 'Power0',
            duration: 300,
            onComplete: () => {
                if(this.bigWinTween && this.bigWinTween.isPlaying()) {
                    this.bigWinTween.stop();
                    this.bigWinTween.remove();
                }

                if(this.bigWinLeafRingTween && this.bigWinLeafRingTween.isPlaying()) {
                    this.bigWinLeafRingTween.stop();
                    this.bigWinLeafRingTween.remove();
                }

                if(this.bigWinContainer) {
                    this.bigWinContainer.destroy();
                }
        
                if(this.bigWinAmountContainer) {
                    this.bigWinAmountContainer.destroy()
                }

                if(this.leafRing) {
                    this.leafRing.destroy();
                }
                
                this.ticketFinished();
            }
        });
    }

    bigWinPositioner() {
        if(!this.bigWinContainer) {
            return;
        }

        this.bigWinContainer.x = this.cameras.main.centerX;
        this.bigWinContainer.y = this.cameras.main.centerY;

        this.bigWinContainer.setSize(this.cameras.main.width, this.cameras.main.height);

        this.leafRing.setX(0).setY(0);

        this.bwLightningShort1.setX(-50).setY(-( this.leafRing.height / 2) + 110);
        this.bwLightningShort2.setX(0).setY(this.leafRing.height / 2 - 110);

        this.bwLightningShort3.setX(-( this.leafRing.width / 2) + 110).setY(30);
        this.bwLightningShort4.setX(this.leafRing.width / 2 - 110).setY(-30);

        this.bwLightningLong1.setX(-(this.leafRing.width)).setY(-250);
        this.bwLightningLong2.setX(this.leafRing.width + 40).setY(-150);
        this.bwLightningLong3.setX(this.leafRing.width - 45).setY(350);

        this.bwLightningMedium1.setX(-(this.leafRing.width / 2) - 270).setY(150);
        this.bwLightningMedium2.setX(+(this.leafRing.width / 2) + 270).setY(150);
        this.bwLightningMedium3.setX(-(this.leafRing.width / 2) - 140).setY(450);

        this.bwLightningShort5.setX(0).setY(-(this.leafRing.height / 2) - 100);
        this.bwLightningShort6.setX(350).setY(-(this.leafRing.height / 2) + 50);
        this.bwLightningShort7.setX(0).setY((this.leafRing.height / 2) + 100);
        this.bwLightningShort8.setX(-250).setY((this.leafRing.height / 2) + 40);

        this.bigWinTitle.setY(45);

        if (Config.assets.settings && Config.assets.settings.win_amount_center) {
            this.bigWinAmountContainer.setY(0);
        } else {
            this.bigWinAmountContainer.setY(this.bigWinAmountContainer.height / 2 + 20);
        }

        this.bigWinAmountContainer.originalY = this.bigWinAmountContainer.y;

        this.bigWinLightsContainer.x = 0;
        this.bigWinLightsContainer.y = 0;

        if(this.orientationIsSetToPortrait()) {
            this.bigWinLightsContainer.setAngle(90);
        } else {
            this.bigWinLightsContainer.setAngle(0);
        }
    }

    incrementTo(winning) {
        let lastAmount = 0;
        let delay = 0;

        if(lastAmount === winning) {
            this.setAmountText(delay, winning, true, 1, callback) 
        } else {
            if(!this.pointCountSound.isPlaying) {
                this.pointCountSound.play();
            }

            var incrementSize = winning / 45;
    
            if(incrementSize < 0.01) {
                incrementSize = 0.01;
            }
            
            if(parseFloat(incrementSize) > 1) {
                incrementSize = Math.ceil(incrementSize);
            }

            while(lastAmount !== winning) {
                lastAmount += incrementSize;
    
                if(lastAmount > winning) {
                    lastAmount = winning;
                }

                this.setAmountText(delay, lastAmount, lastAmount === winning) 
    
                delay += 55;
            }
        }
    }

    setAmountText(delay, amount, last) {
        amount = General.format_currency(amount).replace(Config.currency.symbol, '');

        this.time.delayedCall(delay, () => {
            let scale = this.bigWinAmountContainer.scaleX;
            let x = this.bigWinAmountContainer.x;
            let y = this.bigWinAmountContainer.y;

            this.bigWinAmountContainer.destroy();

            if (this.bigWinDestroyed) {
                return;
            }

            this.bigWinAmountContainer = this.customHelper.createWinningFromSprites(amount, 1, '_winning_counter', -10)
                .setX(x)
                .setY(y)
                .setScale(scale);

            this.bigWinContainer.add(this.bigWinAmountContainer);

            if(last) {
                this.pointCountSound.stop();
                this.sound.play('sfx-last-point');

                this.tweens.add({
                    targets: this.leafRing,
                    scale: 1.2,
                    ease: 'Power0',
                    duration: 300,
                    delay: 1000,
                    onComplete: () => {
                        this.destroyBigWin();
                    }
                });
            }
        }, this);
    }

    gamePositioner() {
        if(!this.spritesReady) {
            return;
        }

        this.regularWinPositioner();
        this.bigWinPositioner();

        if(this.alignGrid) {
            this.alignGrid.destroy();
            delete this.alignGrid;
        }
        
        this.alignGrid = new AlignGrid({
            'scene': this,
            'cols': 21,
            'rows': 21
        });

        if (this.bonusTweens) {
            for (let key in this.bonusTweens) {
                if (this.bonusTweens[key].isPlaying()) {
                    this.bonusTweens[key].stop();
                    this.bonusTweens[key].remove();
                }
            }

            this.bonusTweens = [];
        }
        
        //this.alignGrid.showNumbers();

        if(this.orientationIsSetToPortrait()) {
            this.bg.setTexture('bg_portrait');
            this.zeus.setAlpha(0);
            this.temple.setAlpha(0);
            this.zeusPortrait.setAlpha(1);
            this.templePortrait.setAlpha(1);
            this.cloudLayer5.setAlpha(1);
            this.cloudLayer6.setAlpha(1);

            this.mainFrame.setX(0).setY(-530);
            this.omegaCover.setX(-1).setY(-395);
            this.omegaCoverMultiplier.setX(this.omegaCover.x).setY(-470);
            this.omegaCoverFx.setX(this.omegaCover.x).setY(this.omegaCoverMultiplier.y);
            this.bonusDarkFader.setX(0).setY(0);

            this.alignGrid.placeAtIndex(58, this.logo, 0, -60);

            this.cloudLayer1.setX(this.cameras.main.width);
            this.cloudLayer2.setX(this.cameras.main.width);
            this.cloudLayer3.setX(0);
            this.cloudLayer4.setX(this.cameras.main.width);

            this.mainGameGroup.currentOriginX = this.cameras.main.centerX;
            this.mainGameGroup.currentOriginY = this.cameras.main.height - 850;
            this.cloudLayer1.currentOriginX = this.cameras.main.width;
            this.cloudLayer1.currentOriginY = -(this.cloudLayer1.height);
            this.cloudLayer2.currentOriginX = this.cameras.main.width;
            this.cloudLayer2.currentOriginY = -(this.cloudLayer2.height);
            this.cloudLayer3.currentOriginX = 0;
            this.cloudLayer3.currentOriginY = 0;
            this.cloudLayer4.currentOriginX = this.cameras.main.width;
            this.cloudLayer4.currentOriginY = 0;
            this.cloudLayer5.currentOriginX = 0;
            this.cloudLayer5.currentOriginY = this.cameras.main.height - 350;
            this.cloudLayer6.currentOriginX = 0;
            this.cloudLayer6.currentOriginY = this.cameras.main.height;
            this.zeusPortrait.currentOriginX = 0;
            this.zeusPortrait.currentOriginY = this.cameras.main.height / 2 + 10;
            this.templePortrait.currentOriginX = this.cameras.main.width;
            this.templePortrait.currentOriginY = this.cameras.main.height / 2 + 300;

            this.mainGameGroup.setScale(0.95);

            if(!this.bonusRunning) {
                this.mainGameGroup
                    .setX(this.mainGameGroup.currentOriginX)
                    .setY(this.mainGameGroup.currentOriginY);

                this.bonusContainer
                    .setX(this.cameras.main.centerX)
                    .setY(-(this.cameras.main.height + this.cameras.main.height / 2));

                this.bonusContainer.currentOriginX = this.bonusContainer.x;
                this.bonusContainer.currentOriginY = this.bonusContainer.y;

                this.cloudLayer1.setX(this.cloudLayer1.currentOriginX).setY(this.cloudLayer1.currentOriginY);
                this.cloudLayer2.setX(this.cloudLayer2.currentOriginX).setY(this.cloudLayer2.currentOriginY);
                this.cloudLayer3.setX(this.cloudLayer3.currentOriginX);
                this.cloudLayer4.setX(this.cloudLayer4.currentOriginY);
                this.cloudLayer5.setX(this.cloudLayer5.currentOriginX).setY(this.cloudLayer5.currentOriginY);
                this.cloudLayer6.setX(this.cloudLayer6.currentOriginX).setY(this.cloudLayer6.currentOriginY);
                this.zeusPortrait.setX(this.zeusPortrait.currentOriginX).setY(this.zeusPortrait.currentOriginY);
                this.templePortrait.setX(this.templePortrait.currentOriginX).setY(this.templePortrait.currentOriginY);
            } else {
                this.cloudLayer1.setY(0);
                this.cloudLayer2.setY(800);
                this.cloudLayer3.setY(100);
                this.cloudLayer4.setY(800);
                this.cloudLayer5.setY(this.cameras.main.height + this.cloudLayer5.height / 2);
                this.cloudLayer6.setY(this.cameras.main.height + this.cloudLayer5.height / 2);
                this.zeusPortrait.setY(this.cameras.main.height + 100);
                this.templePortrait.setY(this.cameras.main.height + this.cameras.main.height / 2);
                this.bonusContainer
                    .setX(this.cameras.main.centerX)
                    .setY(this.cameras.main.centerY - 330);

                this.mainGameGroup
                    .setX(this.cameras.main.centerX)
                    .setY(this.cameras.main.height + this.cameras.main.height / 2);
            }

            this.frontContainerFader.setX(-(this.cameras.main.width/2)).setY(-(this.cameras.main.height/2) - 300);
        } else {
            this.bg.setTexture('bg');
            this.zeus.setAlpha(1);
            this.temple.setAlpha(1);
            this.alignGrid.placeAtIndex(60, this.logo, 0, 30);
            this.cloudLayer5.setAlpha(0);
            this.cloudLayer6.setAlpha(0);
            this.zeusPortrait.setAlpha(0);
            this.templePortrait.setAlpha(0);

            this.mainFrame.setX(0).setY(-(this.cameras.main.height / 2) + 10);
            this.temple.setX(this.cameras.main.width / 2 + 48).setY(this.cameras.main.height / 2);
            this.omegaCover.setX(-1).setY(-(this.cameras.main.height / 2) + 145);
            this.omegaCoverMultiplier.setX(this.omegaCover.x).setY(-(this.cameras.main.height / 2) + 70);
            this.omegaCoverFx.setX(this.omegaCover.x).setY(this.omegaCoverMultiplier.y);
            this.bonusDarkFader.setX(0).setY(0);
            this.zeus.setX(0).setY(this.cameras.main.height);

            this.cloudLayer1.setX(this.cameras.main.width);
            this.cloudLayer2.setX(this.cameras.main.width);
            this.cloudLayer3.setX(0);
            this.cloudLayer4.setX(this.cameras.main.width);

            this.mainGameGroup.currentOriginX = this.cameras.main.centerX;
            this.mainGameGroup.currentOriginY = this.cameras.main.centerY - 30;
            this.cloudLayer1.currentOriginX = this.cameras.main.width;
            this.cloudLayer1.currentOriginY = -100;
            this.cloudLayer2.currentOriginX = this.cameras.main.width;
            this.cloudLayer2.currentOriginY = 0;
            this.cloudLayer3.currentOriginX = 0;
            this.cloudLayer3.currentOriginY = 0;
            this.cloudLayer4.currentOriginX = this.cameras.main.width;
            this.cloudLayer4.currentOriginY = 0;
            this.mainGameGroup.setScale(0.95);

            if(!this.bonusRunning) {
                this.mainGameGroup
                    .setX(this.mainGameGroup.currentOriginX)
                    .setY(this.mainGameGroup.currentOriginY);
                this.bonusContainer
                    .setX(this.cameras.main.centerX)
                    .setY(-(this.cameras.main.height + this.cameras.main.height / 2));

                this.bonusContainer.currentOriginX = this.bonusContainer.x;
                this.bonusContainer.currentOriginY = this.bonusContainer.y;

                this.cloudLayer1.setY(this.cloudLayer1.currentOriginY);
            } else {
                this.cloudLayer1.setY(0);
                this.cloudLayer2.setY(400);
                this.cloudLayer3.setY(50);
                this.cloudLayer4.setY(50);

                this.bonusContainer
                    .setX(this.cameras.main.centerX)
                    .setY(this.cameras.main.centerY);

                this.mainGameGroup
                    .setX(this.cameras.main.centerX)
                    .setY(this.cameras.main.height + this.cameras.main.height / 2);
            }

            this.frontContainerFader.setX(-(this.cameras.main.width/2)).setY(-(this.cameras.main.height/2));
        }

        this.frontContainer
            .setX(this.mainGameGroup.x)
            .setY(this.mainGameGroup.y);

        this.bg.setY(this.cameras.main.height);
    }

    showMultiplier() {
        this.openedYourSymbolsLucky.sort((a, b) => a.y - b.y);

        this.time.delayedCall(1000, () => {
            this.omegaCoverFx.play('multiplier_fx');

            this.multiplierShoot(this.omegaCoverFx, this.openedYourSymbolsLucky[0], 0, this.openedYourSymbolsLucky.length === 1);

            let delay = 500;

            for (let key in this.openedYourSymbolsLucky) {
                const intKey = parseInt(key)
                const isLast = intKey === this.openedYourSymbolsLucky.length-2;

                this.multiplierShoot(this.openedYourSymbolsLucky[key], (this.openedYourSymbolsLucky[intKey+1] ? this.openedYourSymbolsLucky[intKey+1] : false), delay, isLast);
                delay += 500;
            }
        });
    }

    multiplierShoot(from, to, delay, last) {
        if (to) {
            this.time.delayedCall(delay, () => {
                let x = to.amount.x;
                let y = to.amount.y;

                to.amount.destroy();
                to.amount = this.customHelper
                    .createWinningFromSprites(to.amount_after, 1, '_winnings', -10)
                    .setX(x)
                    .setY(y);
                
                this.request.addAmountWon(to.amount_add_to_won);
        
                this.customHelper.applyDynamicSpriteSize(to.amount, to.displayWidth);

                this.mainGameGroup.add(to.amount);

                this.shootLightningFromTo(
                    from.x + this.mainGameGroup.x, 
                    from.y + this.mainGameGroup.y, 
                    to.x + this.mainGameGroup.x, 
                    to.y + this.mainGameGroup.y
                );

                to.fronEffect.play('win_fx_regular');
                this.burstCoins(to.x + this.mainGameGroup.x, to.y + this.mainGameGroup.y);
                if (last) {
                    this.time.delayedCall(1000, () => {
                        this.finishGame();
                    });
                }
            });
        }
    }

    defineYourNumbersCoors() {
        this.yourNumbersCoors = {
            0: {
                x:-379,
                y:-225
            },
            1: {
                x:-216,
                y:-385
            },
            2: {
                x:218,
                y:-385
            },
            3: {
                x:379,
                y:-225
            },
            4: {
                x:379,
                y:207
            },
            5: {
                x:218,
                y:364
            },
            6: {
                x:-215,
                y:364
            },
            7: {
                x:-379,
                y:206
            },
            8: {
                x:-165,
                y:-178
            },
            9: {
                x:2,
                y:-248
            },
            10: {
                x:169,
                y:-178
            },
            11: {
                x:169,
                y:158
            },
            12: {
                x:2,
                y:228
            },
            13: {
                x:-165,
                y:158
            }
        };
    }
}

class AnimatedParticle extends Phaser.GameObjects.Particles.Particle
{
    constructor (emitter)
    {
        super(emitter);

        this.t = 0;
        this.i = Math.floor(Math.random() * 7);
    }

    update (delta, step, processors)
    {
        var result = super.update(delta, step, processors);

        this.t += delta;

        if (this.t >= coinsAnim.msPerFrame)
        {
            this.i++;

            if (this.i > 7)
            {
                this.i = 0;
            }

            this.frame = coinsAnim.frames[this.i].frame;

            this.t -= coinsAnim.msPerFrame;
        }

        return result;
    }
}

startGame(GameScene);